/** @format */
import { Trans, useTranslation } from 'next-i18next';
import React, { FunctionComponent, HTMLAttributes, useContext } from 'react';

import { ApplicationContext } from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';

import { Link, LinkTarget } from '@toucan/client/shared/components/link';

export const MarketingUnsubscribeDisclaimer: FunctionComponent<
    HTMLAttributes<HTMLParagraphElement>
> = (props) => {
    const { legalLinks } = useContext(ApplicationContext);
    const { activeMarket } = useContext(MarketContext);
    const { t } = useTranslation();

    return (
        <p {...props}>
            <Trans
                components={{
                    'privacy-link': (
                        <Link
                            href={`/${activeMarket.slug}/${legalLinks?.privacyPage?.urlSlug}`}
                            target={LinkTarget.BLANK}
                            aria-label={t('view our privacy policy')}
                        />
                    ),
                }}
            >
                {t(
                    "It's easy to unsubscribe from emails and offers. For more details on how we handle your data, <privacy-link>view our privacy policy</privacy-link>."
                )}
            </Trans>
        </p>
    );
};
